<template>

  <Head>
    <Title>Služby a ceny - Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu />
  <v-container>
    <v-sheet class="mx-4">
      <h1>Hodnocení</h1>
    </v-sheet>
    <v-row>
      <v-col cols="12" md="6">
        <siteblocks-review title="David Procházka" image="/reviews/David_Prochazka.jpg">
          "Ludmila fotí naši rodinu již několik let, ať již při slavnostnějších příležitostech (oslavy, svátky) či „jen
          tak“.
          Kromě jednotlivých fotografií máme i velmi pěknou fotoknihu, která zachycuje, jak děti rostou (a my rodiče
          stárneme).
          Pokud hledáte profesionálního fotografa, mohu vřele doporučit Ludmilu. Díky osobnímu přístupu dokáže skvěle
          zachytit
          atmosféru a vy si budete moci i po čase připomenout emoce a pocity, které jste v daném okamžiku
          prožívali se svými nejbližšími."
        </siteblocks-review>
      </v-col>

      <v-col cols="12" md="6">
        <siteblocks-review title="Patrick Medina" image="/reviews/Patrik.jpg">
          "Ludmila je už několik let naší první volbou pro vánoční rodinné focení. Jako bývalý profesionální fotograf
          jsem na kvalitu dost náročný, ale její práce mě pokaždé nadchne. Má talent na to, aby se i naše malé děti
          cítily uvolněně a přirozeně zapózovaly, a její úpravy fotek jsou vždy perfektní. Určitě jejích služeb budeme
          využívat i nadále. Ve skutečnosti už teď plánujeme zarezervovat focení venku na podzim."
          (překlad z angličtiny)
        </siteblocks-review>
      </v-col>

      <v-col cols="12" md="6">
        <siteblocks-review title="Jana Segi Lukavská" image="/reviews/Jana_Segi.jpg">
          "Nikdy jsem si focení vyloženě neužívala a třeba pózovat se mi zdálo vyloženě trapné.
          Při našem focení mi ale všechno, co se dělo, připadalo přirozené. Neměla jsem pocit, že bych byla do čehokoliv
          tlačená,
          a focení velmi příjemně uteklo. Vlastně šlo o takovou milou procházku, ze které ale mně
          i mojí dceři navíc zbyla spousta krásných fotek s hřejivou atmosférou."
        </siteblocks-review>
      </v-col>

      <v-col cols="12" md="6">
        <siteblocks-review title="Taťána Skloná" image="/reviews/Tatana_Sklona.jpg">
          "Moc děkujeme paní Ludmíle za nádherné fotky naší dcery. Kvalita fotografií předčila naše očekávání,
          s fotografiemi se rádi pochlubíme každé návštěvě.Líbí se mi, že na Lyudmilinch fotografiích vidím obyčejné
          lidi, ne modelky,
          s různými postavami. Ale všechny vypadají krásně a esteticky. Vřele doporučuji. Vám všem, stojí to za to!"
        </siteblocks-review>
      </v-col>


      <v-col cols="12" md="6">
        <siteblocks-review title="Anastasie Kuzněcova" image="/reviews/Anastasie_Kuznecova.jpg">
          "Děkujeme moc za focení. Máme krásné fotky s procházky parkem, vánoční fotky a s novým miminkem )))
          Ludmila vždy měla hodně nápadu, bylo vidět, že si připravovala,
          prohlížela reference a přemyšlela o tom, jak chce ukázat nás. Bylo moc zajímavé ještě objevovat sebe skrz její
          oči."
        </siteblocks-review>
      </v-col>

      <v-col cols="12" md="6">
        <siteblocks-review title="Bára Brieu" image="/reviews/Bara.jpg">
          "Foceni s Ludmilou je moc příjemný zážitek. Je velice milá a pohodova a výsledek je parádní! Mohu vřele
          doporučit!"
        </siteblocks-review>
      </v-col>

    </v-row>
  </v-container>
</template>